export const getSide = (placement) => placement.split('-')[0];
